/*
  Esteira de compra (estilo Apple e Ultrahuman) dentro da seção de compra.

  - Resumo do pedido (blocks/halo-resumo.liquid): produto com a cor e o tamanho escolhidos,
    as escolhas pagas (blocks/halo-escolha.liquid), os acessórios marcados
    (blocks/halo-compre-junto.liquid) e o total. Recalcula a cada troca. Com o preço cheio
    ligado, cada item e o total mostram o preço cheio riscado e o valor real, e embaixo do
    total aparece quanto o cliente economiza.
  - Cupom (ex.: BLACKHALO, ligado no HALO Resumo): os acessórios marcados como brinde aparecem
    grátis, o fechamento ganha a linha do desconto do cupom e o total vira "Total com o cupom".
    O card do cupom copia o código com um toque. O desconto real é da Yampi, no checkout.
  - Etapas seguintes ao seletor (data-halo-etapa) ficam apagadas e inertes enquanto o tamanho
    obrigatório não foi escolhido (seletor com data-halo-lock); um clique numa delas abre os
    tamanhos com o aviso (assets/halo-seletor.js). No editor do tema nada fica apagado.
  - Etapas com "Esconder até o cliente escolher o tamanho" (data-halo-ocultar) ficam escondidas
    (CSS) enquanto o tamanho não foi escolhido e aparecem com a altura animada depois.

  - O "Comprar" da barra fixa leva à seção de compra (não ao topo da página).

  Não adiciona nada ao carrinho: isso é do assets/halo-compre-junto.js.
*/
(function () {
  'use strict';

  if (window.haloEsteira) return;
  window.haloEsteira = true;

  function designMode() {
    return !!(window.Shopify && window.Shopify.designMode);
  }

  function scopeOf(el) {
    return (el && el.closest('xo-product')) || document;
  }

  function sizePending(picker) {
    return !!(
      picker &&
      picker.hasAttribute('data-halo-require-size') &&
      picker.dataset.haloSizeChosen !== 'true' &&
      picker.querySelector('[data-halo-size]')
    );
  }

  function money(cents, box) {
    try {
      return new Intl.NumberFormat(box.dataset.idioma || 'pt-BR', {
        style: 'currency',
        currency: box.dataset.moeda || 'BRL',
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  // "R$ 1.234,56" e "$1,234.56" viram 123456 (centavos). Preços digitados no HALO Compre junto.
  // O separador seguido de 1 ou 2 dígitos no fim é o decimal; os outros são de milhar.
  function parsePrice(text) {
    var clean = String(text || '').replace(/[^\d,.]/g, '').replace(/[,.]+$/, '');
    if (!clean) return null;
    var decimal = clean.match(/[,.](\d{1,2})$/);
    var whole = decimal ? clean.slice(0, -decimal[0].length) : clean;
    clean = whole.replace(/[,.]/g, '') + (decimal ? '.' + decimal[1] : '');
    var value = parseFloat(clean);
    return isNaN(value) ? null : Math.round(value * 100);
  }

  function variants(box) {
    if (!box.haloVariants) {
      var el = box.querySelector('[data-halo-resumo-variantes]');
      try {
        box.haloVariants = JSON.parse(el.textContent);
      } catch (e) {
        box.haloVariants = [];
      }
    }
    return box.haloVariants;
  }

  // Variante escolhida: pelas opções marcadas no seletor (na hora do clique) ou pelo id do
  // formulário de compra (o tema atualiza depois de redesenhar o seletor).
  function currentVariant(box, scope) {
    var list = variants(box);
    var picker = scope.querySelector('xo-product-variants');
    if (picker) {
      var values = [];
      picker.querySelectorAll('.xo-product-variant__item').forEach(function (row) {
        var input = row.querySelector('input:checked');
        var select = row.querySelector('select');
        values.push(input ? input.value : select ? select.value : null);
      });
      if (values.length) {
        for (var i = 0; i < list.length; i++) {
          var match = list[i].o.every(function (option, k) {
            return values[k] == null || values[k] === option;
          });
          if (match) return list[i];
        }
      }
    }
    var idInput = scope.querySelector('form[action*="/cart/add"] [name="id"]');
    var id = idInput ? Number(idInput.value) : 0;
    for (var j = 0; j < list.length; j++) {
      if (list[j].id === id) return list[j];
    }
    return list[0] || null;
  }

  function variantText(box, scope, variant) {
    var picker = scope.querySelector('.halo-picker');
    // Produto sem variações ("Default Title"): só o nome, sem linha de variante.
    var title = variant && variant.t !== 'Default Title' ? variant.t : '';
    if (!picker) return title;
    var parts = [];
    var chosen = picker.querySelector('[data-halo-chosen]');
    if (chosen && chosen.textContent.trim()) parts.push(chosen.textContent.trim());
    var size = picker.querySelector('[data-halo-size]');
    if (size) {
      if (sizePending(picker)) {
        parts.push(box.dataset.tamanhoPendente || '');
      } else {
        var input = size.querySelector('input:checked');
        var row = size.closest('.xo-product-variant__item');
        var label = row && row.querySelector('.xo-product-variant-label');
        var name = label ? label.textContent.trim() : '';
        if (input) parts.push((name ? name + ' ' : '') + input.value);
      }
    }
    return parts.length ? parts.join(' · ') : title;
  }

  // Cada linha: nome, valor real (cents) e preço cheio (full). Opção inclusa: valor 0 e
  // texto "Incluso"; o preço cheio dela só existe se foi preenchido no bloco.
  function extraLines(box, scope) {
    var out = [];
    scope.querySelectorAll('[data-halo-escolha]').forEach(function (step) {
      var input = step.querySelector('.halo-escolha__input:checked');
      if (!input) return;
      if (input.hasAttribute('data-halo-opcao-inclusa')) {
        var included = parsePrice(input.dataset.precoCheioTexto) || 0;
        if (box.dataset.mostrarIncluso === 'true' || included) {
          out.push({ name: input.dataset.nome, text: box.dataset.incluso, cents: 0, full: included });
        }
        return;
      }
      // Preço levando junto (digitado no bloco) ou o preço da variante.
      var cents = parsePrice(input.dataset.precoTexto);
      if (cents == null) cents = Number(input.dataset.preco) || 0;
      out.push({ name: input.dataset.nome, cents: cents, full: Math.max(cents, Number(input.dataset.precoCheio) || 0) });
    });
    // Item já incluso no pedido (ex.: pulseira preta da Band), mostrado no HALO Compre junto.
    scope.querySelectorAll('[data-halo-incluso]').forEach(function (el) {
      var included = parsePrice(el.dataset.precoCheioTexto) || 0;
      if (box.dataset.mostrarIncluso === 'true' || included) {
        out.push({ name: el.dataset.nome, text: box.dataset.incluso, cents: 0, full: included });
      }
    });
    // Preço na compra junto limitado a algumas unidades por item (ex.: 1 pulseira): conta por grupo.
    var promoUsed = {};
    scope.querySelectorAll('[data-hcj-check]:checked:not(:disabled)').forEach(function (input) {
      // Quantidade (cores em pop-up): o preço multiplica e o nome ganha "2 × ".
      var qty = Math.max(1, Number(input.dataset.hcjQtd) || 1);
      var cents = parsePrice(input.dataset.hcjPrecoTexto);
      if (cents == null) cents = Number(input.dataset.hcjPreco) || 0;
      var full = parsePrice(input.dataset.hcjPrecoCheioTexto);
      if (full == null) full = Number(input.dataset.hcjPreco) || cents;
      var limit = Number(input.dataset.hcjPromoLimite) || 0;
      if (limit && input.dataset.hcjGrupo) {
        var group = input.dataset.hcjGrupo;
        var used = promoUsed[group] || 0;
        var promoUnits = Math.max(0, Math.min(qty, limit - used));
        var unitFull = Math.max(cents, full);
        promoUsed[group] = used + promoUnits;
        out.push({
          name: (qty > 1 ? qty + ' × ' : '') + (input.dataset.hcjNome || ''),
          cents: cents * promoUnits + unitFull * (qty - promoUnits),
          full: unitFull * qty,
        });
        return;
      }
      if (qty > 1) {
        out.push({ name: qty + ' × ' + (input.dataset.hcjNome || ''), cents: cents * qty, full: Math.max(cents, full) * qty });
        return;
      }
      // Brinde do cupom: grátis no resumo. O cupom zera o preço com que o item entra no
      // carrinho (o do produto), que fica em "coupon".
      if (box.dataset.cupom && input.hasAttribute('data-hcj-cupom')) {
        var price = Number(input.dataset.hcjPreco) || cents;
        out.push({ name: input.dataset.hcjNome || '', text: box.dataset.cupomGratis, cents: 0, full: Math.max(price, full), coupon: price });
        return;
      }
      out.push({ name: input.dataset.hcjNome || '', cents: cents, full: Math.max(cents, full) });
    });
    return out;
  }

  // Coluna de preço: o valor real em cima e, se maior, o preço cheio riscado embaixo, com os
  // rótulos para leitor de tela.
  function priceNodes(box, full, now, nowText) {
    var frag = document.createDocumentFragment();
    var compare = box.dataset.mostrarCheio === 'true' && full > now;
    var span = document.createElement('span');
    span.className = 'halo-resumo__agora';
    if (compare) span.appendChild(srLabel(box.dataset.rotuloAgora));
    span.appendChild(document.createTextNode(nowText != null ? nowText : money(now, box)));
    frag.appendChild(span);
    if (compare) {
      var s = document.createElement('s');
      s.className = 'halo-resumo__cheio';
      s.appendChild(srLabel(box.dataset.rotuloCheio));
      s.appendChild(document.createTextNode(money(full, box)));
      frag.appendChild(s);
    }
    return frag;
  }

  function srLabel(text) {
    var sr = document.createElement('span');
    sr.className = 'halo-resumo__sr';
    sr.textContent = (text || '') + ' ';
    return sr;
  }

  function update(box) {
    var scope = scopeOf(box);
    var variant = currentVariant(box, scope);
    var qtyInput = scope.querySelector('form[action*="/cart/add"] [name="quantity"]');
    var qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
    var main = (variant ? variant.p : 0) * qty;
    var mainFull = Math.max(main, (variant ? variant.c || 0 : 0) * qty);
    var total = main;
    var totalFull = mainFull;

    var price = box.querySelector('[data-halo-resumo-preco]');
    if (price) {
      price.textContent = '';
      price.appendChild(priceNodes(box, mainFull, main, (qty > 1 ? qty + ' × ' : '') + money(main, box)));
    }

    var line = box.querySelector('[data-halo-resumo-variante]');
    if (line) line.textContent = variantText(box, scope, variant);

    var list = box.querySelector('[data-halo-resumo-linhas]');
    var extras = extraLines(box, scope);
    if (list) {
      list.textContent = '';
      extras.forEach(function (extra) {
        var li = document.createElement('li');
        li.className = 'halo-resumo__item halo-resumo__linha';
        var name = document.createElement('span');
        name.className = 'halo-resumo__linha-nome';
        name.textContent = extra.name;
        var value = document.createElement('span');
        value.className = 'halo-resumo__valores';
        value.appendChild(priceNodes(box, extra.full || 0, extra.cents || 0, extra.text != null ? extra.text : null));
        li.appendChild(name);
        li.appendChild(value);
        list.appendChild(li);
      });
      list.hidden = extras.length === 0;
    }
    var coupon = 0;
    extras.forEach(function (extra) {
      total += extra.cents || 0;
      totalFull += Math.max(extra.cents || 0, extra.full || 0);
      coupon += extra.coupon || 0;
    });

    // Cupom: linha do desconto, rótulo do total e aviso de que o desconto entra no checkout.
    var couponRow = box.querySelector('[data-halo-resumo-cupom]');
    var couponValue = box.querySelector('[data-halo-resumo-cupom-valor]');
    if (couponRow) couponRow.hidden = coupon === 0;
    if (couponValue) couponValue.textContent = coupon ? '\u2212\u00a0' + money(coupon, box) : '';
    var couponNote = box.querySelector('[data-halo-resumo-cupom-nota]');
    if (couponNote) couponNote.hidden = coupon === 0;
    var totalLabel = box.querySelector('[data-halo-resumo-total-rotulo]');
    if (totalLabel) {
      totalLabel.textContent = (coupon && totalLabel.dataset.cupom) || totalLabel.dataset.normal || totalLabel.textContent;
    }

    var totalEl = box.querySelector('[data-halo-resumo-total]');
    if (totalEl) totalEl.textContent = money(total, box);

    // Fechamento: preço cheio (riscado), economia e total.
    var compare = box.dataset.mostrarCheio === 'true' && totalFull > total;
    var fullRow = box.querySelector('[data-halo-resumo-total-cheio]');
    var fullValue = box.querySelector('[data-halo-resumo-total-cheio-valor]');
    if (fullRow) fullRow.hidden = !compare;
    if (fullValue) fullValue.textContent = money(totalFull, box);
    var savingsRow = box.querySelector('[data-halo-resumo-economia]');
    var savingsValue = box.querySelector('[data-halo-resumo-economia-valor]');
    // Sem outro desconto além do cupom (ex.: Halo Band), a economia repetiria a linha do cupom.
    if (savingsRow) savingsRow.hidden = !compare || totalFull - total === coupon;
    if (savingsValue) savingsValue.textContent = compare ? money(totalFull - total, box) : '';
  }

  var reduceQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  // Etapa escondida até o tamanho: some na hora; aparece com a altura, a margem e a opacidade
  // animadas (as que aparecem juntas entram uma depois da outra).
  function setHidden(step, hide, order) {
    if (hide === !step.classList.contains('is-revelada')) return;
    if (hide) {
      step.classList.remove('is-revelada');
      return;
    }
    step.classList.add('is-revelada');
    if (order < 0 || reduceQuery.matches || !step.animate) return;
    var height = step.offsetHeight;
    var marginTop = getComputedStyle(step).marginTop;
    step.style.overflow = 'hidden';
    var anim = step.animate(
      [
        { height: '0px', marginTop: '0px', opacity: 0, transform: 'translateY(-6px)' },
        { height: height + 'px', marginTop: marginTop, opacity: 1, transform: 'none' }
      ],
      { duration: 480, delay: order * 90, easing: 'cubic-bezier(0.2, 0.8, 0.2, 1)', fill: 'backwards' }
    );
    anim.onfinish = anim.oncancel = function () {
      step.style.overflow = '';
    };
  }

  function updateLocks() {
    var design = designMode();
    var revealed = 0;
    document.querySelectorAll('.halo-picker[data-halo-require-size]').forEach(function (picker) {
      var pending = !design && sizePending(picker);
      var lock = picker.hasAttribute('data-halo-lock');
      scopeOf(picker).querySelectorAll('[data-halo-etapa]').forEach(function (step) {
        if (!(picker.compareDocumentPosition(step) & Node.DOCUMENT_POSITION_FOLLOWING)) return;
        if (step.hasAttribute('data-halo-ocultar')) {
          step.haloControlada = true;
          var wasHidden = !step.classList.contains('is-revelada');
          setHidden(step, pending, step.haloVista ? revealed : -1);
          if (wasHidden && !pending) revealed += 1;
          step.haloVista = true;
          return;
        }
        if (!lock) return;
        if (step.classList.contains('is-bloqueada') === pending) return;
        step.classList.toggle('is-bloqueada', pending);
        if (pending) step.setAttribute('aria-disabled', 'true');
        else step.removeAttribute('aria-disabled');
        Array.prototype.forEach.call(step.children, function (child) {
          if (child.classList.contains('halo-etapa__titulo')) return;
          if (pending) child.setAttribute('inert', '');
          else child.removeAttribute('inert');
        });
      });
    });
    // Sem seletor de tamanho que a controle, a etapa fica visível.
    document.querySelectorAll('[data-halo-ocultar]:not(.is-revelada)').forEach(function (step) {
      if (!step.haloControlada) setHidden(step, false, -1);
    });
  }

  function refresh() {
    document.querySelectorAll('[data-halo-resumo]').forEach(update);
    updateLocks();
  }

  // O tema troca a variante de forma assíncrona: recalcula na hora e de novo logo depois.
  var timers = [];
  function soon() {
    timers.forEach(clearTimeout);
    refresh();
    timers = [setTimeout(refresh, 350), setTimeout(refresh, 1000)];
  }

  // Card do cupom: copia o código e confirma no botão e no aviso. Se o navegador não deixar
  // copiar, o código fica selecionado para o cliente copiar na mão.
  function copyFallback(text) {
    var area = document.createElement('textarea');
    area.value = text;
    area.setAttribute('readonly', '');
    area.style.cssText = 'position:fixed;top:0;left:0;opacity:0;font-size:16px';
    document.body.appendChild(area);
    area.select();
    area.setSelectionRange(0, text.length);
    var ok = false;
    try {
      ok = document.execCommand('copy');
    } catch (e) {}
    area.remove();
    return ok;
  }

  // Área de transferência moderna; se o navegador recusar, o método antigo.
  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text).catch(function () {
        if (!copyFallback(text)) throw new Error('copy');
      });
    }
    return copyFallback(text) ? Promise.resolve() : Promise.reject(new Error('copy'));
  }

  document.addEventListener('click', function (e) {
    var button = e.target.closest && e.target.closest('[data-halo-cupom-copiar]');
    if (!button) return;
    var card = button.closest('[data-halo-cupom]');
    var label = button.querySelector('[data-halo-cupom-rotulo]');
    var status = card && card.querySelector('[data-halo-cupom-status]');
    copyText(button.dataset.codigo || '').then(
      function () {
        button.classList.add('is-copiado');
        if (label) label.textContent = label.dataset.copiado || label.textContent;
        if (status) status.textContent = status.dataset.texto || '';
        clearTimeout(button.haloTimer);
        button.haloTimer = setTimeout(function () {
          button.classList.remove('is-copiado');
          if (label) label.textContent = label.dataset.copiar || label.textContent;
        }, 4000);
      },
      function () {
        var code = button.querySelector('.halo-cupom__codigo');
        if (!code || !window.getSelection) return;
        var range = document.createRange();
        range.selectNodeContents(code);
        var selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
      }
    );
  });

  // Etapa apagada: o clique leva ao tamanho.
  document.addEventListener('click', function (e) {
    var step = e.target.closest && e.target.closest('.halo-etapa.is-bloqueada');
    if (!step) return;
    e.preventDefault();
    var picker = scopeOf(step).querySelector('.halo-picker[data-halo-lock]');
    if (picker) picker.dispatchEvent(new CustomEvent('halo:pedir-tamanho', { bubbles: true }));
  });

  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('xo-product')) soon();
  });
  document.addEventListener('input', function (e) {
    if (e.target.name === 'quantity') soon();
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('xo-product form[action*="/cart/add"]')) setTimeout(soon, 0);
  });
  document.addEventListener('halo:tamanho', soon);

  document.addEventListener('halo:extras', soon);

  function watch() {
    document.querySelectorAll('.halo-picker').forEach(function (picker) {
      if (picker.haloEsteiraWatched) return;
      picker.haloEsteiraWatched = true;
      new MutationObserver(soon).observe(picker, { childList: true });
    });
  }

  function init() {
    watch();
    refresh();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', init);
  document.addEventListener('shopify:block:deselect', init);
})();
